export default "__VITE_ASSET__IqvJnHkf__"